// Add your custom JS here.
( function( $ ) {




    var lastScrollTop = 0;

    $(window).on("scroll", function () {
        var st = $(this).scrollTop();

        // Add/remove 'down' class based on scroll direction
        if (st > lastScrollTop) {
            $('.site-header').addClass('down');
        } else {
            $('.site-header').removeClass('down');
        }
        lastScrollTop = st;

        // Add/remove 'scrolled' class based on scroll position
        if (st > 56) {
            $('.site-header').addClass('scrolled');
        } else {
            $('.site-header').removeClass('scrolled');
        }
    });


    // SMOOOTH SCROLLING
    $('a[href*="#"]').on('click', function(e) {

        // Check if the anchor link is for the current page
        if (this.pathname === window.location.pathname && this.hash) {
            e.preventDefault(); // Prevent default anchor behavior

            var target = $(this.hash);
            if (target.length) {
                // Disable smooth scrolling temporarily
                $('html').css('scroll-behavior', 'auto');

                // Scroll to the target element
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function() {
                    // Re-enable smooth scrolling after scrolling is complete
                    $('html').css('scroll-behavior', 'smooth');
                });
            }
        }
    });















    // Start hero videos right after DOM ready so mobile playback begins quickly.
    function initDeferredHeroVideos() {
        document.querySelectorAll('video[data-hero-video-src]').forEach((video) => {
            const src = video.getAttribute('data-hero-video-src');
            if (!src || video.querySelector('source')) {
                return;
            }

            const source = document.createElement('source');
            source.src = src;
            source.type = video.getAttribute('data-hero-video-type') || 'video/mp4';
            video.appendChild(source);
            video.load();
            video.play().catch(() => {});
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDeferredHeroVideos, { once: true });
    } else {
        initDeferredHeroVideos();
    }

    // Vertical Swiper Configuration (only when markup exists)
    if (typeof Swiper !== 'undefined' && document.querySelector('.vertical-swiper')) {
        new Swiper('.vertical-swiper', {
            direction: 'vertical',
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 2000,
                disableOnInteraction: false,
            },
            speed: 600,
            navigation: false,
            pagination: false,
        });
    }








    // Select the iframe
    const iframe = document.getElementById('vimeoplayer');

    if (iframe) {
        // Initialize the Vimeo Player
        const player = new Vimeo.Player(iframe);

        // Play button click handler
        $(".playbutton").on("click", function () {
            player.play();
            $(".video-popup").addClass("active");
        });

        // Close button click handler
        $(".video-popup .close").on("click", function () {
            player.pause();
            $(".video-popup").removeClass("active");
        });
    } 





    $(".close-popup").on("click", function () {
        $(this).parent().fadeOut(150);
    });




    $(".insurance-popup i").on("click", function () {
        $(this).parent().addClass("hide");
    });




    $(".quote-btn").on("click", function () {
        $(".request-popup").addClass("active");
    });

    $(".request-popup .close").on("click", function () {
        $(".request-popup").removeClass("active");
    });




    $(".backdrop").on("click", function () {
        $(".main-menu, .backdrop, .dropdown-container, .menu-icon").removeClass("active");
    });


    $(".backdrop").on("click", function () {
        $(".primary-navigation, .backdrop, .menu-toggle").removeClass("active");
    });


$(".site-header__mobile-toggle").on("click", function () {
    if ($(this).hasClass("active")) {
        // Close
        $(this).removeClass("active");
        $(".site-header").removeClass("active");
        $(".site-header__dropdown-overlay").removeClass("is-visible");
        $(".site-header__dropdown.is-open").removeClass("is-open");
    } else {
        // Open
        $(".site-header").addClass("active");
        $(this).addClass("active");
        $(".site-header__dropdown-overlay").addClass("is-visible");
    }
});

    
    ////////////// GSAP (loaded only on pages that need animations) //////////////
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);









// Select all headings within .fade-title-in
const headings = document.querySelectorAll('.fade-title-in h1, .fade-title-in h2');

headings.forEach((heading) => {
    // Function to wrap words in text nodes only, preserving all HTML
    function wrapWordsInTextNodes(element) {
        // Create a TreeWalker to find all text nodes
        const walker = document.createTreeWalker(
            element,
            NodeFilter.SHOW_TEXT,
            {
                acceptNode: function(node) {
                    // Only process text nodes that contain non-whitespace content
                    return node.textContent.trim().length > 0 ? 
                        NodeFilter.FILTER_ACCEPT : 
                        NodeFilter.FILTER_REJECT;
                }
            }
        );

        const textNodes = [];
        let node;
        
        // Collect all text nodes first (to avoid modifying while iterating)
        while (node = walker.nextNode()) {
            textNodes.push(node);
        }

        // Process each text node
        textNodes.forEach(textNode => {
            const text = textNode.textContent;
            
            // Skip if the text node only contains whitespace
            if (!text.trim()) return;
            
            // Split text into words, preserving spaces
            const parts = text.split(/(\s+)/);
            
            // Create a document fragment to hold the new elements
            const fragment = document.createDocumentFragment();
            
            parts.forEach(part => {
                if (part.trim()) {
                    // This is a word - wrap it
                    const wordWrapper = document.createElement('span');
                    wordWrapper.className = 'word-wrapper';
                    
                    const wordSpan = document.createElement('span');
                    wordSpan.className = 'word';
                    wordSpan.textContent = part;
                    
                    wordWrapper.appendChild(wordSpan);
                    fragment.appendChild(wordWrapper);
                } else {
                    // This is whitespace - preserve it as text node
                    const spaceNode = document.createTextNode(part);
                    fragment.appendChild(spaceNode);
                }
            });
            
            // Replace the original text node with our wrapped version
            textNode.parentNode.replaceChild(fragment, textNode);
        });
    }

    // Apply the word wrapping to this heading
    wrapWordsInTextNodes(heading);
    
    // Add CSS to ensure proper display
    // const style = document.createElement('style');
    // if (!document.querySelector('#word-wrapper-styles')) {
    //     style.id = 'word-wrapper-styles';
    //     style.textContent = `
    //         // .word-wrapper {
    //         //     display: inline-block;
    //         //     overflow: hidden;
    //         // }
    //         // .word {
    //         //     display: inline-block;
    //         //     transform: translateY(0);
    //         // }
    //     `;
    //     document.head.appendChild(style);
    // }
    
    // Animate the words on scroll
    gsap.fromTo(
        heading.querySelectorAll('.word'),
        { 
            y: '100%', 
            opacity: 0 
        },
        {
            y: '0%',
            opacity: 1,
            stagger: 0.05,
            duration: 0.6,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: heading,
                start: 'top 80%',
                end: 'bottom 20%',
                toggleActions: 'play none none none',
            },
        }
    );
});






// Subtle H3 animation (chunk/line-ish fade up)
const h3s = document.querySelectorAll('.fade-title-in h3');

h3s.forEach((h3) => {
  // Don’t double-process if you re-init scripts
  if (h3.dataset.h3Animated === '1') return;
  h3.dataset.h3Animated = '1';

  // Preserve existing HTML: wrap only text nodes into chunks
  const walker = document.createTreeWalker(
    h3,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        return node.textContent.trim().length
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    }
  );

  const textNodes = [];
  let node;
  while ((node = walker.nextNode())) textNodes.push(node);

  textNodes.forEach((textNode) => {
    const text = textNode.textContent;
    if (!text.trim()) return;

    // Split into "line-ish" chunks. Tune this:
    // - if you use <br> in H3, keep those and split by newline.
    // - otherwise split by punctuation, but keep punctuation.
    const chunks = text.split(/([.!?]+|\n)/g).filter(Boolean);

    const frag = document.createDocumentFragment();
    let buffer = '';

    chunks.forEach((chunk) => {
      buffer += chunk;

      const isBreak =
        chunk === '\n' || /[.!?]+/.test(chunk);

      if (isBreak) {
        const span = document.createElement('span');
        span.className = 'h3-line';
        span.textContent = buffer.trim();
        frag.appendChild(span);

        // preserve spacing after chunk
        frag.appendChild(document.createTextNode(' '));

        buffer = '';
      }
    });

    // leftover
    if (buffer.trim()) {
      const span = document.createElement('span');
      span.className = 'h3-line';
      span.textContent = buffer.trim();
      frag.appendChild(span);
    }

    textNode.parentNode.replaceChild(frag, textNode);
  });

  gsap.fromTo(
    h3.querySelectorAll('.h3-line'),
    { y: 10, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      duration: 0.45,
      ease: 'power2.out',
      stagger: 0.08,
      scrollTrigger: {
        trigger: h3,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
    }
  );
});





// Alternative simpler version if you want to be extra safe
// This version is more conservative and handles edge cases better
function robustWordWrapper(headings) {
    headings.forEach((heading) => {
        // Store original content for fallback
        const originalContent = heading.innerHTML;
        
        try {
            // Create a temporary container to work with
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = originalContent;
            
            // Function to recursively process nodes
            function processNode(node) {
                if (node.nodeType === Node.TEXT_NODE) {
                    const text = node.textContent;
                    if (text.trim()) {
                        // Split into words and spaces
                        const words = text.split(/(\s+)/);
                        const fragment = document.createDocumentFragment();
                        
                        words.forEach(word => {
                            if (word.trim()) {
                                // Create word wrapper
                                const wrapper = document.createElement('span');
                                wrapper.className = 'word-wrapper';
                                const span = document.createElement('span');
                                span.className = 'word';
                                span.textContent = word;
                                wrapper.appendChild(span);
                                fragment.appendChild(wrapper);
                            } else {
                                // Preserve whitespace
                                fragment.appendChild(document.createTextNode(word));
                            }
                        });
                        
                        return fragment;
                    }
                } else if (node.nodeType === Node.ELEMENT_NODE) {
                    // Process child nodes
                    const children = Array.from(node.childNodes);
                    children.forEach(child => {
                        const processed = processNode(child);
                        if (processed) {
                            node.replaceChild(processed, child);
                        }
                    });
                }
                return node;
            }
            
            // Process all nodes in the temporary container
            Array.from(tempDiv.childNodes).forEach(child => {
                processNode(child);
            });
            
            // Replace the heading content
            heading.innerHTML = tempDiv.innerHTML;
            
        } catch (error) {
            // Fallback: restore original content if anything goes wrong
            console.warn('Word wrapping failed, using original content:', error);
            heading.innerHTML = originalContent;
            return; // Skip animation for this heading
        }
        
        // Animate the words
        gsap.fromTo(
            heading.querySelectorAll('.word'),
            { y: '100%', opacity: 0 },
            {
                y: '0%',
                opacity: 1,
                stagger: 0.05,
                duration: 0.6,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: heading,
                    start: 'top 80%',
                    end: 'bottom 20%',
                    toggleActions: 'play none none none',
                },
            }
        );
    });
}









    // Select all media items
    const mediaItems = document.querySelectorAll(".parallax>img, .parallax>video, .parallax>iframe, .parallax>svg");

    mediaItems.forEach((item) => {
        gsap.fromTo(
            item,
            { y: 50 }, // Start slightly down
            {
                y: -50, // Move slightly up
                ease: "none", // Linear parallax effect
                scrollTrigger: {
                    trigger: item, // Each media item triggers its own parallax
                    start: "top bottom", // Start when the item enters the viewport
                    end: "bottom top", // End when the item leaves the viewport
                    scrub: true, // Smoothly link animation to scroll
                },
            }
        );
    });









    // Select all media items
    const mparItems = document.querySelectorAll(".parall");

    mparItems.forEach((item) => {
        gsap.fromTo(
            item,
            { y: 100 }, // Start slightly down
            {
                y: -100, // Move slightly up
                ease: "none", // Linear parallax effect
                scrollTrigger: {
                    trigger: item, // Each media item triggers its own parallax
                    start: "top bottom", // Start when the item enters the viewport
                    end: "bottom top", // End when the item leaves the viewport
                    scrub: true, // Smoothly link animation to scroll
                },
            }
        );
    });



// Add sliding hover effect to header menu links
document.addEventListener('DOMContentLoaded', function() {
    const menuLinks = document.querySelectorAll('.site-header__menu-link');
    
    menuLinks.forEach(link => {
        // Skip if already processed
        if (link.classList.contains('header-link-sliding-processed')) return;
        
        // Get all child nodes
        const childNodes = Array.from(link.childNodes);
        
        // Separate text nodes and SVG
        let textContent = '';
        let svgElement = null;
        
        childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                textContent += node.textContent;
            } else if (node.tagName === 'svg' || node.tagName === 'SVG') {
                svgElement = node.cloneNode(true);
            }
        });
        
        // If no text content, skip
        if (!textContent.trim()) return;
        
        // Create wrapper for sliding effect
        const wrapper = document.createElement('span');
        wrapper.classList.add('header-link-sliding-wrapper');
        
        // Create two content holders (original and duplicate)
        const contentTop = document.createElement('span');
        contentTop.classList.add('header-link-sliding-content');
        contentTop.textContent = textContent.trim();
        if (svgElement) {
            contentTop.appendChild(svgElement.cloneNode(true));
        }
        
        const contentBottom = document.createElement('span');
        contentBottom.classList.add('header-link-sliding-content');
        contentBottom.textContent = textContent.trim();
        if (svgElement) {
            contentBottom.appendChild(svgElement.cloneNode(true));
        }
        
        // Build structure
        wrapper.appendChild(contentTop);
        wrapper.appendChild(contentBottom);
        
        // Replace link content with wrapper
        link.innerHTML = '';
        link.appendChild(wrapper);
        
        // Mark as processed
        link.classList.add('header-link-sliding-processed');
    });
});

// Add sliding hover effect to all buttons (ignore selects and minimal buttons)
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.btn, .button');

  buttons.forEach(button => {
    // ❌ Ignore <select> elements or select-like buttons
    if (
      button.tagName === 'SELECT' ||
      button.closest('select') ||
      button.getAttribute('role') === 'listbox' ||
      button.classList.contains('minimal') ||
      button.classList.contains('site-header__button')
    ) {
      return;
    }

    // Skip if already processed
    if (button.classList.contains('btn-sliding-processed')) return;

    // Get the original content
    const originalContent = button.innerHTML;

    // Create wrapper for sliding effect
    const wrapper = document.createElement('span');
    wrapper.classList.add('btn-sliding-wrapper');

    // Create two content holders (original and duplicate)
    const contentTop = document.createElement('span');
    contentTop.classList.add('btn-sliding-content');
    contentTop.innerHTML = originalContent;

    const contentBottom = document.createElement('span');
    contentBottom.classList.add('btn-sliding-content');
    contentBottom.innerHTML = originalContent;

    // Build structure
    wrapper.appendChild(contentTop);
    wrapper.appendChild(contentBottom);

    // Replace button content with wrapper
    button.innerHTML = '';
    button.appendChild(wrapper);

    // Mark as processed
    button.classList.add('btn-sliding-processed');
  });
});




    // Add sliding hover effect to all footer links
    document.addEventListener('DOMContentLoaded', function() {
        const footerLinks = document.querySelectorAll('.site-footer a');
        
        footerLinks.forEach(link => {
            // Skip if already processed or if it's an image-only link
            if (link.classList.contains('footer-link-sliding-processed')) return;
            
            // Skip links that only contain images (like logo links)
            const hasOnlyImage = link.children.length === 1 && link.children[0].tagName === 'IMG';
            if (hasOnlyImage) return;
            
            // Skip social links with only SVG
            const hasOnlySVG = link.children.length === 1 && link.children[0].tagName === 'svg';
            if (hasOnlySVG) return;
            
            // Get the original content
            const originalContent = link.innerHTML;
            
            // Create wrapper for sliding effect
            const wrapper = document.createElement('span');
            wrapper.classList.add('footer-link-sliding-wrapper');
            
            // Create two content holders (original and duplicate)
            const contentTop = document.createElement('span');
            contentTop.classList.add('footer-link-sliding-content');
            contentTop.innerHTML = originalContent;
            
            const contentBottom = document.createElement('span');
            contentBottom.classList.add('footer-link-sliding-content');
            contentBottom.innerHTML = originalContent;
            
            // Build structure
            wrapper.appendChild(contentTop);
            wrapper.appendChild(contentBottom);
            
            // Replace link content with wrapper
            link.innerHTML = '';
            link.appendChild(wrapper);
            
            // Mark as processed
            link.classList.add('footer-link-sliding-processed');
        });
    });





    // Select all elements with the .fade-in-up class
    const fadeInElements = document.querySelectorAll(".fade-in-up");

    // Check if any .fade-in-up elements exist
    if (fadeInElements.length > 0) {
        fadeInElements.forEach((element) => {
            gsap.from(element, {
                opacity: 0,
                y: 50, // Slide-up effect
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: element,
                    start: "top 90%", // Start animation when the element's top reaches 80% of the viewport
                    toggleActions: "play none none reverse", // Play on scroll down, reverse on scroll up
                    once: false, // Set to true if the animation should trigger only once
                }
            });
        });
    }












    

    // Function to animate countup elements
    if ($('.countup').length) {
        function initCountUp() {
        const countupElements = gsap.utils.toArray('.countup');
        
        countupElements.forEach(element => {
            // Get the original text content
            const originalText = element.textContent.trim();
            
            // Parse the text to extract number and any prefix/suffix
            const match = originalText.match(/^([^0-9]*)(\d+)(.*)$/);
            
            if (!match) return; // Skip if no number found
            
            const prefix = match[1]; // + or -
            const number = parseInt(match[2]);
            const suffix = match[3]; // % or other characters
            
            // Set initial value to 0
            element.textContent = prefix + '0' + suffix;
            
            // Create the animation
            const countUpAnimation = gsap.to(element, {
            duration: 2,
            ease: "power1.out",
            onUpdate: function() {
                const progress = this.progress();
                const currentValue = Math.round(number * progress);
                element.textContent = prefix + currentValue + suffix;
            },
            scrollTrigger: {
                trigger: element,
                start: "top 80%", // Start when element is 80% from top of viewport
                once: true, // Only animate once
            }
            });
        });
        }

        // Initialize on page load
        document.addEventListener('DOMContentLoaded', initCountUp);
    }

    } // end GSAP block










    /**
     * Video Modal Functionality - Vimeo Only Version
     */
    function initVideoModals() {
        // Get the modal elements
        const videoModal = document.getElementById('video-modal');
        const videoModalClose = document.getElementById('video-modal-close');
        const videoModalIframeContainer = document.getElementById('video-modal-iframe-container');
        
        if (!videoModal) return; // Exit if modal doesn't exist
        
        // Get all play buttons
        const videoPlayButtons = document.querySelectorAll('.video-play-button');
        
        // Add click event to all play buttons
        videoPlayButtons.forEach(button => {
            button.addEventListener('click', function() {
                const videoId = this.getAttribute('data-video-id');
                const videoUrl = this.getAttribute('data-video-url');
                
                // Create iframe
                const iframe = document.createElement('iframe');
                iframe.setAttribute('src', videoUrl);
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allowfullscreen', 'true');
                iframe.setAttribute('allow', 'autoplay; fullscreen');
                iframe.setAttribute('id', 'video-iframe-' + videoId);
                
                // Clear existing iframe and add new one
                videoModalIframeContainer.innerHTML = '';
                videoModalIframeContainer.appendChild(iframe);
                
                // Open modal
                videoModal.classList.add('active');
                
                // Prevent scrolling on body
                document.body.style.overflow = 'hidden';
            });
        });
        
        // Close modal when clicking the close button
        videoModalClose.addEventListener('click', closeModal);
        
        // Close modal when clicking outside the content
        videoModal.addEventListener('click', function(event) {
            if (event.target === videoModal) {
                closeModal();
            }
        });
        
        // Close modal with ESC key
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && videoModal.classList.contains('active')) {
                closeModal();
            }
        });
        
        function closeModal() {
            // Remove active class
            videoModal.classList.remove('active');
            
            // Empty iframe container to stop video
            videoModalIframeContainer.innerHTML = '';
            
            // Restore scrolling
            document.body.style.overflow = '';
        }
    }

    // Initialize when DOM is ready
    document.addEventListener('DOMContentLoaded', initVideoModals);







    // Toggle functionality for accordion items
    $('.content-section__toggle-header').on('click', function() {
        var $button = $(this);
        var $toggle = $button.closest('.content-section__toggle');
        var $content = $('#' + $button.attr('aria-controls'));
        var $toggleGroup = $button.closest('.content-section__toggles');
        var isExpanded = $button.attr('aria-expanded') === 'true';
        
        // Prevent CSS transitions from interfering
        $content.css('transition', 'none');
        
        if (isExpanded) {
            // Close this toggle
            $button.attr('aria-expanded', 'false');
            $toggle.removeClass('is-open');
            $content.slideUp(300, function() {
                // Re-enable transitions after animation
                $(this).css('transition', '');
            });
        } else {
            // Close any open toggles in the same group
            $toggleGroup.find('.content-section__toggle.is-open').each(function() {
                var $openToggle = $(this);
                var $openButton = $openToggle.find('.content-section__toggle-header');
                var $openContent = $('#' + $openButton.attr('aria-controls'));
                
                $openContent.css('transition', 'none');
                $openButton.attr('aria-expanded', 'false');
                $openToggle.removeClass('is-open');
                $openContent.slideUp(300, function() {
                    $(this).css('transition', '');
                });
            });
            
            // Open this toggle
            $button.attr('aria-expanded', 'true');
            $toggle.addClass('is-open');
            $content.slideDown(300, function() {
                // Re-enable transitions after animation
                $(this).css('transition', '');
            });
        }
    });





/**
 * GSAP Animations for Centered Content Section
 * 
 * Requires GSAP and ScrollTrigger plugin
 * Add this to your main JS file or enqueue separately
 */

(function() {
    'use strict';
    
    // Wait for GSAP and DOM to be ready
    if (typeof gsap === 'undefined') {
        console.warn('GSAP not loaded - centered content animations disabled');
        return;
    }
    
    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);
    
    /**
     * Initialize animations for a centered content section
     */
    function initCenteredContentAnimations(section) {
        const rotateCircle = section.querySelector('[data-rotate-circle]');
        const rotateImage = section.querySelector('[data-rotate-image]');
        const mediaTicker = section.querySelector('[data-media-ticker]');
        
        if (!rotateCircle && !mediaTicker) return;
        
        // ========================================
        // CIRCULAR LOGO ANIMATIONS
        // ========================================
        
        if (rotateCircle) {
            // 1. Continuous auto-rotation (slow)
            gsap.to(rotateCircle, {
                rotation: 360,
                duration: 30, // 30 seconds per full rotation
                ease: 'none',
                repeat: -1
            });
            
            // 2. Additional scroll-based rotation
            gsap.to(rotateImage, {
                rotation: 360,
                ease: 'none',
                scrollTrigger: {
                    trigger: section,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: 1, // Smooth scrubbing (1 second delay)
                }
            });
        }
        
        // ========================================
        // MEDIA TICKER ANIMATIONS
        // ========================================
        
        if (mediaTicker) {
            const tickerItems = mediaTicker.children;
            if (tickerItems.length === 0) return;
            
            // Wait for all images and videos to load before calculating widths
            const mediaElements = Array.from(mediaTicker.querySelectorAll('img, video'));
            
            const initTickerAnimation = () => {
                // Force a reflow to ensure accurate measurements
                mediaTicker.style.display = 'none';
                mediaTicker.offsetHeight; // Trigger reflow
                mediaTicker.style.display = '';
                
                // Calculate total width for seamless loop
                let totalWidth = 0;
                Array.from(tickerItems).forEach(item => {
                    totalWidth += item.offsetWidth;
                });
                
                // Fallback if width is still 0
                if (totalWidth === 0) {
                    console.warn('Ticker width is 0, retrying...');
                    setTimeout(initTickerAnimation, 100);
                    return;
                }
                
                // We duplicated items 3x in PHP, so actual content is 1/3 of total
                const contentWidth = totalWidth / 3;
                
                // 1. Continuous auto-scroll (very slow, leftward)
                const autoScrollTween = gsap.to(mediaTicker, {
                    x: -contentWidth,
                    duration: 60, // 60 seconds to scroll through one set
                    ease: 'none',
                    repeat: -1,
                    modifiers: {
                        x: gsap.utils.unitize(x => parseFloat(x) % contentWidth)
                    }
                });
                
                // 2. Scroll velocity effect
                let scrollVelocity = 0;
                let lastScrollY = 0;
                
                ScrollTrigger.create({
                    trigger: section,
                    start: 'top bottom',
                    end: 'bottom top',
                    onUpdate: (self) => {
                        // Calculate scroll velocity
                        const currentScrollY = self.scroll();
                        scrollVelocity = currentScrollY - lastScrollY;
                        lastScrollY = currentScrollY;
                        
                        // Adjust ticker speed based on scroll velocity
                        // Faster scroll = faster ticker movement
                        const velocityFactor = Math.abs(scrollVelocity) * 0.002; // Adjust multiplier as needed
                        const newTimeScale = 1 + velocityFactor;
                        
                        gsap.to(autoScrollTween, {
                            timeScale: newTimeScale,
                            duration: 0.3,
                            ease: 'power2.out'
                        });
                    }
                });
                
                // Refresh ScrollTrigger after initialization
                ScrollTrigger.refresh();
            };
            
            // Wait for all media to load
            if (mediaElements.length > 0) {
                let loadedCount = 0;
                const totalMedia = mediaElements.length;
                
                const checkAllLoaded = () => {
                    loadedCount++;
                    if (loadedCount >= totalMedia) {
                        // Add a small delay to ensure layout is stable
                        setTimeout(initTickerAnimation, 100);
                    }
                };
                
                mediaElements.forEach(media => {
                    if (media.tagName === 'IMG') {
                        if (media.complete) {
                            checkAllLoaded();
                        } else {
                            media.addEventListener('load', checkAllLoaded);
                            media.addEventListener('error', checkAllLoaded); // Count errors too
                        }
                    } else if (media.tagName === 'VIDEO') {
                        if (media.readyState >= 2) { // HAVE_CURRENT_DATA or better
                            checkAllLoaded();
                        } else {
                            media.addEventListener('loadeddata', checkAllLoaded);
                            media.addEventListener('error', checkAllLoaded); // Count errors too
                        }
                    }
                });
            } else {
                // No media elements, init immediately
                initTickerAnimation();
            }
            
            // Play videos when they become visible (optional)
            const videos = mediaTicker.querySelectorAll('video');
            videos.forEach(video => {
                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                video.play().catch(() => {}); // Ignore autoplay errors
                            } else {
                                video.pause();
                            }
                        });
                    },
                    { threshold: 0.5 }
                );
                observer.observe(video);
            });
        }
    }
    
    /**
     * Initialize all centered content sections on the page
     */
    function initAll() {
        const sections = document.querySelectorAll('.centered-content-section');
        sections.forEach(section => {
            initCenteredContentAnimations(section);
        });
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }
    
    // Re-initialize ScrollTrigger on window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            ScrollTrigger.refresh();
        }, 250);
    });
    
})();



    $('.map-modal__container, .team-modal__container, .downloads-modal__container').on('click', function(e) {
        if (e.target === this) {
            $(this).parent().removeClass('is-open');
            $('body').css('overflow', '');
        }
    });










    // Add this to your theme's JavaScript file
function inspyriumIntro() {
  const hasSeenIntro = sessionStorage.getItem('inspyrium_intro_shown');
  const introElement = document.getElementById('inspyrium-intro');
  
  if (!introElement) return;
  
  if (hasSeenIntro) {
    introElement.style.display = 'none';
    return;
  }
  
  document.body.style.overflow = 'hidden';
  
  const progressFill = document.getElementById('progress-fill');
  const progressText = document.getElementById('progress-text');
  const startTime = Date.now();
  const minDuration = 2000; // Minimum 2 seconds
  
  let progress = 0;
  let pageLoaded = false;
  
  // Update progress display
  function updateProgress(value) {
    progress = Math.min(value, 100);
    if (progressFill && progressText) {
      progressFill.style.width = progress + '%';
      progressText.textContent = Math.round(progress) + '%';
    }
    
    // For circular progress (if using circle instead)
    const circle = document.getElementById('progress-circle');
    if (circle) {
      const offset = 283 - (283 * progress) / 100;
      circle.style.strokeDashoffset = offset;
    }
  }
  
  // Simulate smooth progress up to 90%
  const interval = setInterval(() => {
    if (progress < 90) {
      progress += Math.random() * 8;
      updateProgress(Math.min(progress, 90));
    }
  }, 150);
  
  // Complete the intro
  function completeIntro() {
    const elapsed = Date.now() - startTime;
    const remainingTime = Math.max(0, minDuration - elapsed);
    
    // Ensure we've been showing for at least 2 seconds
    setTimeout(() => {
      clearInterval(interval);
      updateProgress(100);
      
      // Hold at 100% briefly then fade out
      setTimeout(() => {
        introElement.classList.add('fade-out');
        document.body.style.overflow = 'auto';
        sessionStorage.setItem('inspyrium_intro_shown', 'true');
        
        setTimeout(() => {
          introElement.remove();
        }, 600);
      }, 400);
    }, remainingTime);
  }
  
  // When page is fully loaded
  window.addEventListener('load', () => {
    pageLoaded = true;
    completeIntro();
  });
  
  // Fallback: if page takes too long, force complete after 5 seconds
  setTimeout(() => {
    if (!pageLoaded) {
      pageLoaded = true;
      completeIntro();
    }
  }, 5000);
}

// Run immediately
inspyriumIntro();


})(jQuery);

